import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react-lite";
import DataLayer from "../DataLayer";
import { useStore } from "../../../utils";
import { BRAND_ICON } from "@dp/common";
import BrandIcon from "../BrandIcon";
import i18next from "i18next";

function Header(props) {
  var store = useStore();
  var isMobile = store.isMobile;
  var _store$user = store.user,
      loginModal = _store$user.loginModal,
      isLoggedIn = _store$user.isLoggedIn,
      userProfile = _store$user.userProfile;

  var _onClick = function onClick() {
    loginModal.showLoginModal = true;
    store.platformUtil.dispatchEvent("AnalyticsEvent", "DisplayModal", {
      modalIntent: "open login modal",
      modalContent: "Guest credentials",
      modalName: "Login-Modal"
    });
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "top-header mobile-view",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container mobile-header-container",
        children: [props.mobileLeftNavComp, /*#__PURE__*/_jsx("a", {
          className: "header-logo",
          href: "/home",
          children: /*#__PURE__*/_jsx(BrandIcon, {
            icon: isMobile ? BRAND_ICON.LOGO_MOBILE : BRAND_ICON.LOGO,
            className: ""
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "mobile-sign-in-sing-up-container",
          children: [!isLoggedIn && /*#__PURE__*/_jsx("a", {
            "data-testid": "sign-in-link",
            className: "sign-in-link",
            "data-toggle": "modal",
            onClick: function onClick() {
              _onClick();
            },
            children: i18next.t("mobile.LogIn.btn.label", {
              defaultValue: "Log in"
            })
          }), isLoggedIn && /*#__PURE__*/_jsx("div", {
            className: "mob-account",
            children: /*#__PURE__*/_jsxs("p", {
              children: ["Hi ", userProfile.firstName]
            })
          })]
        })]
      })
    }), /*#__PURE__*/_jsx("nav", {
      className: "navbar navbar-expand-lg navbar-light bg-light desktop-view",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [/*#__PURE__*/_jsx("a", {
          className: "navbar-brand",
          href: "/home",
          children: /*#__PURE__*/_jsx(BrandIcon, {
            icon: isMobile ? BRAND_ICON.LOGO_MOBILE : BRAND_ICON.LOGO,
            className: ""
          })
        }), /*#__PURE__*/_jsx("button", {
          className: "navbar-toggler",
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarNav",
          "aria-controls": "navbarNav",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation",
          children: /*#__PURE__*/_jsx("span", {
            className: "navbar-toggler-icon"
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "navbar-collapse navbar__head",
          id: "navbarNav",
          children: [props.desktopLeftNavComp, /*#__PURE__*/_jsxs("ul", {
            className: "navbar-nav",
            children: [!isLoggedIn && /*#__PURE__*/_jsx("li", {
              className: "nav-item navbar__sign mr-4",
              children: /*#__PURE__*/_jsx("a", {
                className: "nav-link",
                "data-toggle": "modal",
                onClick: function onClick() {
                  _onClick();
                },
                children: i18next.t("mobile.LogIn.btn.label", {
                  defaultValue: "Log in"
                })
              })
            }), isLoggedIn && /*#__PURE__*/_jsx("li", {
              className: " navbar__signed ml-3",
              "data-testid": "logged-in-container",
              children: /*#__PURE__*/_jsxs("a", {
                className: "nav-link no-cursor",
                children: ["Hi ", userProfile.firstName]
              })
            })]
          })]
        })]
      })
    }), /*#__PURE__*/_jsx(DataLayer, {})]
  });
}

export default observer(Header);